var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.72478 5.36617L4.47266 6.61829L8.94453 11.0902L17.8883 2.14641L16.6362 0.894287L8.94453 8.58592L5.72478 5.36617Z",
    fill: "#E9A5F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.04938 14.31C4.56132 14.31 1.78875 11.5374 1.78875 8.04938C1.78875 4.56132 4.56132 1.78875 8.04938 1.78875C9.12263 1.78875 10.1959 2.05706 11.1797 2.59369L12.0741 1.07325C10.8219 0.35775 9.48038 0 8.04938 0C3.5775 0 0 3.5775 0 8.04938C0 12.5213 3.5775 16.0988 8.04938 16.0988C12.5213 16.0988 16.0988 12.5213 16.0988 8.04938H14.31C14.31 11.5374 11.5374 14.31 8.04938 14.31Z",
    fill: "#E9A5F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.0ee9f59500c646ef2c2eab6e34ddc1c1.svg";
export { ForwardRef as ReactComponent };